import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgAttachmentVideoB = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M20.918 3c.217 0 .424.082.574.228l8.282 8c.145.14.226.327.226.522v19c0 1.243-1.075 2.25-2.4 2.25H8.4C7.075 33 6 31.993 6 30.75V5.25C6 4.007 7.075 3 8.4 3zM20.4 4.5h-12c-.442 0-.8.336-.8.75v25.5c0 .414.358.75.8.75h19.2c.442 0 .8-.336.8-.75V12.304h-6.5a1.5 1.5 0 0 1-1.493-1.355l-.007-.144z"
      }), /*#__PURE__*/jsx("path", {
        d: "m16.608 15.285 6.7 4.448c.92.61.923 1.888.007 2.504L16.64 26.71c-1.038.697-2.61.075-2.615-1.245L14 16.542c-.004-1.322 1.566-1.95 2.608-1.257m-1.062 10.21 7.16-4.509-7.187-4.482z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgAttachmentVideoB$1 = SvgAttachmentVideoB;

export { SvgAttachmentVideoB$1 as default };
